<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<h1 mat-dialog-title>{{title}}</h1>

<div mat-dialog-content id="popup-container">
  <form [formGroup]="attributeForm">

    <mat-label>Current Value:</mat-label>
    <br/>
    <div class="current-value-input">
      {{currentValueToUpdate}}
    </div>
    <br/>

    <mat-form-field>
      <mat-label>New Value</mat-label>
      <mat-hint *ngIf="!showCharCount">Required</mat-hint>
      <mat-hint *ngIf="showCharCount">{{attributeForm.get('newValue').value.length}}/{{maxLength}} Characters</mat-hint>
      <input matInput maxlength="{{maxLength}}" formControlName="newValue" id="new-value"/>
      <mat-error *ngIf="attributeForm.get('newValue').hasError('required')">
        New value is <strong>required</strong>.
      </mat-error>
    </mat-form-field>
    <br/>

    <div id="actions-container">
      <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
      <button mat-flat-button id="preview-button" class="action-button"
              [hidden]="hidePreview"
              [disabled]="attributeForm.invalid" (click)="previewChanges()">
        Preview Change
      </button>
      <button mat-raised-button color="primary" id="commit-button" class="action-button"
              [disabled]="attributeForm.invalid"
              (click)="commitChanges()">
        {{saveButtonText}}
      </button>
    </div>
  </form>

</div>
